<template>
    <div v-if="buildingProcessedId > 0 && building.test_qty > 0" class="card buildingCard">
        <div class="card-body buildingCard-body">
            <div class="card-title buildingCard-title">
                        <span class="iconBeforeTitle">
                            <i class="far fa-newspaper"></i>
                         </span>
                Summary
                <ToolTip>
                    <sup class="superScript">
                        <i class="fas fa-info-circle"
                           data-toggle="tooltip"
                           data-placement="top"
                           data-html="true"
                           title=""
                           data-original-title='Device status summary'
                        ></i>
                    </sup>
                </ToolTip>
                <span class="badge badge-info" style="float: right;">Total Devices: {{building.total}}</span>
            </div>
            <div class="card-text">
                <div class="buildingCard-summary">
                    <div class="col">
                        <a href="javascript:void(0)" @click="buildingCardRef['deviceList'].scrollIntoView();eventHub.$emit('filterChange', 'status_error')" class="buildingCard-summary-title text-danger text-decoration-none">{{building.status_error}}</a>
                        <div class="buildingCard-summary-desc">Device Errors</div>
                    </div>
                    <div class="col">
                        <a href="javascript:void(0)" @click="buildingCardRef['deviceList'].scrollIntoView();eventHub.$emit('filterChange', 'status_warning')" class="buildingCard-summary-title text-warning text-decoration-none">{{building.status_warning}}</a>
                        <div class="buildingCard-summary-desc">Device Warnings</div>
                    </div>
                    <div class="col">
                        <a href="javascript:void(0)" @click="buildingCardRef['deviceList'].scrollIntoView();eventHub.$emit('filterChange', 'status_ok')" class="buildingCard-summary-title text-success text-decoration-none">{{building.status_ok}}</a>
                        <div class="buildingCard-summary-desc">Devices OK</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import ToolTip from '@/components/tool-tip/ToolTip.vue';
  export default {
    props: {
      buildingId: Number|String,
      buildingCardRef: Object,
      eventHub: Object
    },
    data () {
      return {}
    },
    created () {
    },
    components: {
      ToolTip
    },
    computed: {
      building: function() {
        return this.$store.getters.building({buildingId: this.buildingProcessedId});
      },
      buildingProcessedId: function () {
        return this.buildingId;
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
    @import "@/../sass/_building_card.scss";
</style>